import { StoreCustomerManagementCustomer } from '../../services/query/storeCustomerManagement/StoreCustomerManagementQuery.services';
import { normalizeTurkishPhoneForApi } from './storeCustomerPhoneSearch.shared';

const getSelectedBackofficeCountryCode = (): string => {
    try {
        const raw = localStorage.getItem('selectedCountry');
        if (!raw) return '';
        return JSON.parse(raw)?.countryCode ?? '';
    } catch {
        return '';
    }
};

/** BFF `0090` + 10 hane → kartta `0 5XXXXXXXXX` (CustomerCardPaper phoneAreaCode + phoneNumber). */
const formatPhoneForCard = (phoneRaw: string): { phoneAreaCode: string; phoneNumber: string } => {
    const trimmed = phoneRaw.trim();
    if (!trimmed) {
        return { phoneAreaCode: '', phoneNumber: '' };
    }

    const normalizedApi = normalizeTurkishPhoneForApi(trimmed);
    const mobileTen =
        normalizedApi.startsWith('0090') && normalizedApi.length >= 14
            ? normalizedApi.slice(4, 14)
            : '';

    if (mobileTen.length === 10 && mobileTen.startsWith('5')) {
        return { phoneAreaCode: '0', phoneNumber: mobileTen };
    }

    return { phoneAreaCode: '', phoneNumber: trimmed };
};

export type StoreCustomerCardCustomer = {
    customerId: number;
    firstName: string;
    lastName: string;
    email: string;
    phoneAreaCode: string;
    phoneNumber: string;
    status: number;
    hasValidatedPhoneNumber: boolean;
    backofficeCustomerEditPhoneNumberShowStatusTemplate: boolean;
    dateOfBirth: string | null;
    emailOptIn: boolean;
    smsOptIn: boolean;
    callOptIn: boolean;
    cultureCode: string;
    languageId: number;
    customerType: string | null;
};

export type StoreCustomerCardDatas = {
    customer: StoreCustomerCardCustomer;
};

/** Card paper shape from global BFF customer (no GetCustomerById). */
export const mapGlobalCustomerToCardDatas = (
    global: StoreCustomerManagementCustomer
): StoreCustomerCardDatas => {
    const countryCode = getSelectedBackofficeCountryCode();
    const detail =
        global.customerDetails?.find((d) => d.countryCode === countryCode) ?? global.customerDetails?.[0];
    const phoneEntry =
        global.customerPhones?.find((p) => p.countryCode === countryCode) ?? global.customerPhones?.[0];
    const { phoneAreaCode, phoneNumber } = formatPhoneForCard(phoneEntry?.phone ?? '');

    return {
        customer: {
            customerId: global.ssoCustomerId,
            firstName: detail?.firstName ?? '',
            lastName: detail?.lastName ?? '',
            email: global.email ?? '',
            phoneAreaCode,
            phoneNumber,
            status: 1,
            hasValidatedPhoneNumber: phoneEntry?.isValid ?? true,
            backofficeCustomerEditPhoneNumberShowStatusTemplate: false,
            dateOfBirth: global.birthDate,
            emailOptIn: global.preferences?.find((p) => p.countryCode === countryCode)?.isEmailOptin ?? false,
            smsOptIn: global.preferences?.find((p) => p.countryCode === countryCode)?.isSmsOptin ?? false,
            callOptIn: global.preferences?.find((p) => p.countryCode === countryCode)?.isCallOptin ?? false,
            cultureCode: global.customerLanguages?.find((l) => l.countryCode === countryCode)?.languageCode ?? 'tr',
            languageId: 0,
            customerType: global.customerType,
        },
    };
};
